import { render } from "./huanbang.vue?vue&type=template&id=2dc62925&scoped=true"
import script from "./huanbang.vue?vue&type=script&lang=js"
export * from "./huanbang.vue?vue&type=script&lang=js"

import "./huanbang.vue?vue&type=style&index=0&id=2dc62925&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc62925"]])

export default __exports__